// @flow

import style from "./style.module.scss";

import React from "react";
import { Container } from "reactstrap";
import { t } from "ttag";

const NoResults = () => (
    <Container className={style.noResultsWrapper}>
        <div className={style.title}>{t`search.noresults.title`}</div>
        <hr className={style.separator} />
        <div className={style.description}>
            {t`search.noresults.description`}
        </div>
    </Container>
);

export default NoResults;
